import React, {createContext, useContext, useReducer, useEffect} from 'react';
import { useEventListener } from "../utils/hooks";

export const UiContext = createContext();

const SET_WIDTH = "SET_WIDTH";
const MOBILE_BREAKPOINT = 1024;
const WIDE_BREAKPOINT = 1280;

const reducerFactory = () => {
  return (state, action) => {
    switch (action.type) {

      case SET_WIDTH:
        return {
          ...state,
          isMobile: action.payload < MOBILE_BREAKPOINT,
          isWide: action.payload >= WIDE_BREAKPOINT,
          width: action.payload,
        }
      default:
        return {
          ...state
        }
    }
  }
}

const UiContextProvider = (props) => {

  const initialWidth = window.innerWidth;
  const initialState = props.initialState || {
    isMobile: initialWidth <= MOBILE_BREAKPOINT,
    isWide: initialWidth >= WIDE_BREAKPOINT,
    width: initialWidth,
    isIOS: (/iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
  }

  const [UiState, dispatch] = useReducer(reducerFactory(), initialState);
  
  const setWidth = () => {
      const currentWidth = window.innerWidth;
      if(currentWidth !== UiState.width){
        dispatch({
          type: SET_WIDTH,
          payload: currentWidth
        });
      }
  }
  useEffect(() => {
    setWidth();
  }, []);

  useEventListener(window, "resize", setWidth);

  const contextValue = [
    UiState,
    {
        dispatch
    }
  ];

  return <UiContext.Provider value={contextValue}>{props.children}</UiContext.Provider>;
}

export default UiContextProvider;

export const useUiContext = () => useContext(UiContext);